import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

interface Request {
  libraryModelId: Uuid;
}

export const deleteLibraryModel = async ({
  libraryModelId,
}: Request): Promise<undefined> => {
  return sylvanus.remove(`/library/model/${libraryModelId}`);
};
